import useTranslation from "next-translate/useTranslation"
import React from "react"
import { useDispatch } from "react-redux"
import { Card, CardBody } from "reactstrap"

import { setFlyoutContentURIAction, toggleFlyoutVisibilityAction } from "@redux/actions/application"


export enum MarketInfoCardType {
  IdeaCard = "ideas",
  ProjectCard = "projects"
}

interface IProps {
  className?: string
  showPicture?: boolean
  type: MarketInfoCardType
}

/**
 * this component provides an infocard for ideas or project
 *
 * is/may be used within the ProjectScroller for ideas or projects
 */
const MarketInfoCard: React.FC<IProps> = ({ className, showPicture = false, type }: IProps) => {
  const { t } = useTranslation("common")

  interface MarketInfoCardOptions {
    header: string
    body: string
    picture: string
    className: string
  }

  let infoCard: MarketInfoCardOptions = null
  switch (type) {
    case MarketInfoCardType.IdeaCard:
      infoCard = {
        header: t("marketplace.ideasInfoCard.header"),
        body: t("marketplace.ideasInfoCard.body"),
        picture: showPicture ? "/assets/img/illustration-ideas.svg" : null,
        className
      }
      break
    case MarketInfoCardType.ProjectCard:
      infoCard = {
        header: t("marketplace.projectsInfoCard.header"),
        body: t("marketplace.projectsInfoCard.body"),
        picture: showPicture ? "/assets/img/illustration-ideas.svg" : null,
        className
      }
  }

  const dispatch = useDispatch()
  const faqKey = "introduction.intro"


  return infoCard && <Card
    className={"project-card market-info-card clickable" + (infoCard.className ? (` ${infoCard.className}`) : "")}
    onClick={() => {
      dispatch(setFlyoutContentURIAction(faqKey))
      dispatch(toggleFlyoutVisibilityAction())
    }}
  >
    {infoCard.picture && <img src={infoCard.picture} />}

    <CardBody    >
      <h3 className="text-center">
        {infoCard.header}
      </h3>
      <p>
        {infoCard.body}
      </p>
    </CardBody>
  </Card>
}

export default MarketInfoCard
